class SalesController extends AbstractController
	@register()
	@inject 'ReportService',
		'RenderRepository'
		'UserInformation'

	initialize: ->
		@filter =
			shop_id: null
			from: moment().startOf('month').unix()
			to: moment().endOf('month').unix()

		@isVatIncluded = true
		@searching = false
		@userHasShopsAssigned = !_.isEmpty(@UserInformation.getSubUser()?.shops)

		@search()

	download: (model, type, format, shopId = null) ->
		query = @RenderRepository.createQuery()
		query.addParameter 'from', @filter.from
		query.addParameter 'to', @filter.to
		query.addParameter 'shop_id', shopId if shopId?

		switch type
			when 'sales_report'
				query.addParameter 'filename', "OrderReport_#{shopId}"
			when 'transactions_sales_report'
				query.addParameter 'filename', "TransactionsReport_#{shopId}"
				query.addParameter 'type', 'transactions_sales_report'
			when 'accounting_categories_report'
				query.addParameter 'filename', "AccountingCategoriesReport_#{shopId}"
				query.addParameter 'type', 'accounting_categories_report'
			when 'user_sales_report'
				query.addParameter 'filename', "UserSalesReport_#{shopId}"
				query.addParameter 'type', 'user_sales_report'
			when 'supplier_sales_report'
				query.addParameter 'filename', "SupplierSalesReport_#{shopId}"
				query.addParameter 'type', 'supplier_sales_report'

		downloadUrl = @RenderRepository.getDownloadUrl model, null, format, query

		@RenderRepository.downloadFromUrl downloadUrl

		return

	search: ->
		@searching = true

		@ReportService
			.getShopsSalesAmounts(@filter.from, @filter.to, @isVatIncluded, @filter.shop_id)
			.then (response) =>
				@turnovers = response
			.finally =>
				@searching = false

	toggleVat: ->
		@isVatIncluded = !@isVatIncluded
		@search()
